import { createFileRoute } from '@tanstack/react-router'
import { HttpStatusPage, httpStatusHead } from '@/components/http-status-page'
import type { HttpStatusData } from '@/components/http-status-page'

const data: HttpStatusData = {
  code: 451,
  name: 'Unavailable For Legal Reasons',
  description:
    'The server is denying access to the resource due to a legal demand. The resource may be censored by government order, blocked due to copyright claims, or restricted by court order. The status code is a reference to Fahrenheit 451.',
  causes: [
    'Government censorship — the content is blocked in the user\'s country due to local laws or regulations.',
    'A DMCA takedown, copyright claim, or other intellectual property enforcement request forced the server to remove or block access.',
    'A court order or legal injunction requires the server to restrict access to specific content.',
  ],
  fixes: [
    'If you are the server operator, the response should include a Link header pointing to the legal entity that required the block, per RFC 7725.',
    'If you are a user, the content is legally restricted in your jurisdiction. A VPN may work but could violate local laws.',
    'If you believe the block is in error, contact the site operator or the legal entity referenced in the response to dispute the claim.',
  ],
  monitoringTip:
    'If a page that should be publicly available starts returning 451, it may indicate an unexpected legal block or misconfigured geo-restriction. Uptrack detects the status code change within 30 seconds and alerts you once several locations confirm it.',
}

export const Route = createFileRoute('/_site/http/451')({
  component: () => <HttpStatusPage data={data} />,
  head: () => httpStatusHead(data),
})
